// EC-847 [FE] Hide Catalog view on search result page
// if search page return true.
function isSerchPage() {
    if (typeof window === "undefined") {
        return false; // Return false on the server to prevent errors
    }
    const pathname = window.location.pathname;
    return pathname.toLowerCase().includes('search');
}

export function isBrickSelectorPage() {
    if (typeof window === "undefined") {
        return false; // Return false on the server to prevent errors
    }
    const pathname = window.location.pathname;
    return pathname.toLowerCase() === ('/catalog/brick-selector');
}

export default isSerchPage;
